import React, { useState } from "react";
import MobileFilterDrawer from "./mobileFilterDrawer";
import { getRankKey, classifyRisk } from "../actions/actions";
import Text from "../components/text";

const CollegeList = ({
  filteredColleges,
  selectedColleges,
  addCollege,
  formData,
  selectedPlaces,
  selectedBranches,
  handlePlaceFilterChange,
  handleBranchFilterChange,
  filteredPlaces,
  filteredBranches,
  placeSearchTerm,
  setPlaceSearchTerm,
  branchSearchTerm,
  setBranchSearchTerm,
  loading, // Add loading prop
  isFullScreen,
}) => {
  // State for mobile filter drawers
  const [showPlaceFilterDrawer, setShowPlaceFilterDrawer] = useState(false);
  const [showBranchFilterDrawer, setShowBranchFilterDrawer] = useState(false);
  const listContainerClass = [
    "laptop-view",
    "overflow-y-auto",
    "border",
    "rounded-lg",
    isFullScreen
      ? "h-[100dvh] min-h-[100dvh] max-h-[100dvh] full-height-block"
      : "max-h-[calc(60vh-120px)]", // Only apply when not full-screen
  ]
    .filter(Boolean)
    .join(" ");

  const rankKey = getRankKey(formData);

  return (
    <div className="w-full">
      {/* Filter Buttons - Mobile-friendly */}
      <div className="mobile-view-1">
        <div className="flex flex-wrap gap-2 mb-4">
          <button
            onClick={(e) => {
              e.stopPropagation();
              setShowPlaceFilterDrawer(true);
            }}
            className={`px-3 py-2 text-sm font-medium rounded-lg border flex items-center gap-2 ${
              selectedPlaces.length > 0
                ? "bg-blue-50 text-blue-700 border-blue-300"
                : "bg-white text-gray-700 border-gray-300"
            }`}
          >
            <span>Location</span>
            {selectedPlaces.length > 0 && (
              <span className="bg-blue-100 text-blue-800 text-xs font-semibold px-2 py-0.5 rounded-full">
                {selectedPlaces.length}
              </span>
            )}
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
          </button>

          <button
            onClick={(e) => {
              e.stopPropagation();
              setShowBranchFilterDrawer(true);
            }}
            className={`px-3 py-2 text-sm font-medium rounded-lg border flex items-center gap-2 ${
              selectedBranches.length > 0
                ? "bg-blue-50 text-blue-700 border-blue-300"
                : "bg-white text-gray-700 border-gray-300"
            }`}
          >
            <span>Branch</span>
            {selectedBranches.length > 0 && (
              <span className="bg-blue-100 text-blue-800 text-xs font-semibold px-2 py-0.5 rounded-full">
                {selectedBranches.length}
              </span>
            )}
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
          </button>
        </div>
      </div>

      {/* Loading Animation */}
      {loading ? (
        <div className="flex justify-center items-center py-8">
          <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500"></div>
        </div>
      ) : filteredColleges.length > 0 ? (
        <div className={listContainerClass}>
        <div className=" laptop-view overflow-y-auto border rounded-lg full-height-block">
          <div className="min-w-full ">
            <table className="w-full table-fixed border-collapse">
              <thead className="bg-gray-50 sticky top-0 z-10">
                <tr>
                  <th className="py-3 pl-4 pr-2 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider w-5/12 md:w-2/5">
                    College
                  </th>
                  <th className="py-3 px-2 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider hidden md:table-cell md:w-1/6">
                    Place
                  </th>
                  <th className="py-3 px-2 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider hidden md:table-cell md:w-1/6">
                    Branch
                  </th>
                  <th className="py-3 px-2 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider w-3/12 md:w-1/6">
                    Rank
                  </th>
                  <th className="py-3 px-2 text-center text-sm font-semibold text-gray-700 uppercase tracking-wider w-2/12 md:w-1/12">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {filteredColleges.map((college, index) => {
                  const collegeRank = parseInt(college[rankKey]) || 0;
                  const studentRank = parseInt(formData.rank) || 0;
                  const riskClass = classifyRisk(studentRank, collegeRank);
                  const isAdded = selectedColleges.some(
                    (c) =>
                      c.inst_code === college.inst_code &&
                      c.branch_code === college.branch_code
                  );

                  const riskBgClass =
                    riskClass === "safety-safe"
                      ? "bg-green-50"
                      : riskClass === "safety-moderate"
                      ? "bg-yellow-50"
                      : riskClass === "safety-ambitious"
                      ? "bg-red-50"
                      : "";

                  const riskIndicator =
                    riskClass === "safety-safe"
                      ? "bg-green-400"
                      : riskClass === "safety-moderate"
                      ? "bg-yellow-400"
                      : "bg-red-400";

                  return (
                    <tr
                      key={index}
                      className={`${riskBgClass} hover:bg-gray-50 transition-colors`}
                    >
                      <td className="py-3 pl-4 pr-2 w-5/12 md:w-2/5">
                        <div className="flex items-start">
                          <div className="flex-shrink-0 w-1 self-stretch">
                            <div
                              className={`w-1 h-full rounded ${riskIndicator}`}
                            ></div>
                          </div>
                          <div className="ml-3 min-w-0 flex-1">
                            <div className="flex items-center mb-1">
                              <span className="font-mono text-xs text-gray-600 bg-gray-100 px-1.5 py-0.5 rounded whitespace-nowrap">
                                {college.inst_code}
                              </span>
                              <span className="md:hidden text-xs text-gray-500 ml-2 truncate">
                                {" - "}
                                {college.place}
                              </span>
                            </div>
                            <p className="text-sm font-medium text-gray-900 break-words line-clamp-2">
                              {college.inst_name}
                            </p>
                          </div>
                        </div>
                      </td>
                      <td className="py-3 px-2 text-sm text-gray-700 hidden md:table-cell md:w-1/6">
                        {college.place}
                      </td>
                      <td className="py-3 px-2 text-sm text-gray-700 hidden md:table-cell md:w-1/6">
                        <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
                          {college.branch_code}
                        </span>
                      </td>
                      <td className="py-3 px-2 w-3/12 md:w-1/6">
                        <div className="font-medium text-sm text-gray-900 mb-1">
                          {collegeRank}
                        </div>
                        <div className="md:hidden">
                          <span className="text-xs py-0.5 px-1.5 bg-blue-100 text-blue-800 rounded inline-block max-w-full truncate">
                            {college.branch_code}
                          </span>
                        </div>
                      </td>
                      <td className="py-3 px-2 text-center w-2/12 md:w-1/12">
                        {isAdded ? (
                          <button
                            type="button"
                            className="w-8 h-8 inline-flex items-center justify-center rounded-full bg-green-100 text-green-600 border border-green-200 cursor-default"
                            disabled
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-4 w-4"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M5 13l4 4L19 7"
                              />
                            </svg>
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="w-8 h-8 inline-flex items-center justify-center rounded-full bg-blue-100 text-blue-600 border border-blue-200 hover:bg-blue-200 hover:border-blue-300 transition-colors"
                            onClick={() => addCollege(college)}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-4 w-4"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                              />
                            </svg>
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div></div>
      ) : (
        <div className="text-center py-8 border rounded-lg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-12 w-12 mx-auto text-gray-400 mb-3"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <p className="text-gray-500 mb-1">
            {Text.CollegeList.NoCollegesFound}
          </p>
          <p className="text-gray-500 text-sm">
            {Text.CollegeList.NoCollegesFoundDescription}
          </p>
        </div>
      )}

      {/* Mobile Filter Drawers */}
      <MobileFilterDrawer
        isOpen={showPlaceFilterDrawer}
        onClose={() => setShowPlaceFilterDrawer(false)}
        title="Filter by Location"
        searchTerm={placeSearchTerm}
        onSearchChange={(e) => setPlaceSearchTerm(e.target.value)}
        filterItems={filteredPlaces}
        selectedItems={selectedPlaces}
        onItemToggle={handlePlaceFilterChange}
        searchPlaceholder="Search locations..."
      />

      <MobileFilterDrawer
        isOpen={showBranchFilterDrawer}
        onClose={() => setShowBranchFilterDrawer(false)}
        title="Filter by Branch"
        searchTerm={branchSearchTerm}
        onSearchChange={(e) => setBranchSearchTerm(e.target.value)}
        filterItems={filteredBranches}
        selectedItems={selectedBranches}
        onItemToggle={handleBranchFilterChange}
        searchPlaceholder="Search branches..."
      />
    </div>
  );
};

export default CollegeList;
